<template>
  <div class="text-center" data-testid="loader">
    <img src="/img/loader.gif"  alt="loader-image" data-testid="loader__image" /><br/>
  </div>
</template>

<script>
  export default {
    data: () => ({
    }),
    methods: {
    }
  }
</script>